export interface Product {
  id: string;
  model: string;
  description: string;
  shortSpecs: string[];
  imageUrl: string;
  productUrl: string;
  criteria: {
    handSize: string[];
    usageType: string[];
    handedness: string;
    userType: string[];
  };
}

export const products: Product[] = [
  {
    "id": "felco-2",
    "model": "FELCO 2",
    "description": "Classic general purpose pruning shear",
    "shortSpecs": ["Right-handed", "Large hand size", "Multi-purpose"],
    "imageUrl": "https://media-library.felco.com/asset/6c9cae18-fb38-408d-aba4-02ec505e71af/Square_packshots_PNG/FELCO_2.png",
    "productUrl": "https://www.felco.com/products/felco-2",
    "criteria": {
      "handSize": ["large"],
      "usageType": ["arboristry_and_forestry", "flowers_and_roses", "fruit_nut_trees_and_orchards", "grapes_and_vineyards", "landscaping_and_municipalities"],
      "handedness": "right",
      "userType": ["professional", "amateur"]
    }
  },
  {
    "id": "felco-4",
    "model": "FELCO 4",
    "description": "Pruning shear for orchards and vineyards",
    "shortSpecs": ["Right-handed", "Large hand size", "Orchard and vineyard use"],
    "imageUrl": "https://media-library.felco.com/asset/c40973a4-0b96-40f3-a1ef-5762ca00179a/Square_packshots_PNG/FELCO_4.png",
    "productUrl": "https://www.felco.com/products/felco-4",
    "criteria": {
      "handSize": ["large"],
      "usageType": ["fruit_nut_trees_and_orchards", "grapes_and_vineyards"],
      "handedness": "right",
      "userType": ["professional", "amateur"]
    }
  },
  {
    "id": "felco-5",
    "model": "FELCO 5",
    "description": "Pruning shear specialized for orchard work",
    "shortSpecs": ["Right-handed", "Large hand size", "Orchard specific"],
    "imageUrl": "https://media-library.felco.com/asset/d8e90d47-f9d4-4cd1-bb2d-9f1ad01dcc75/Square_packshots_PNG/FELCO_5.png",
    "productUrl": "https://www.felco.com/products/felco-5",
    "criteria": {
      "handSize": ["large"],
      "usageType": ["fruit_nut_trees_and_orchards"],
      "handedness": "right",
      "userType": ["professional", "amateur"]
    }
  },
  {
    "id": "felco-6",
    "model": "FELCO 6",
    "description": "Compact pruning shear for medium-sized hands",
    "shortSpecs": ["Right-handed", "Medium hand size", "Versatile use"],
    "imageUrl": "https://media-library.felco.com/asset/91bf3517-89fe-49d5-acf6-f23fabbe812a/Square_packshots_PNG/FELCO_6.png",
    "productUrl": "https://www.felco.com/products/felco-6",
    "criteria": {
      "handSize": ["medium"],
      "usageType": ["arboristry_and_forestry", "flowers_and_roses", "fruit_nut_trees_and_orchards", "grapes_and_vineyards", "hedges_and_bushes", "landscaping_and_municipalities", "nurseries"],
      "handedness": "right",
      "userType": ["professional", "amateur"]
    }
  },
  {
    "id": "felco-6-premium-se",
    "model": "FELCO 6 Premium SE",
    "description": "Premium special edition of the FELCO 6 model",
    "shortSpecs": ["Right-handed", "Medium hand size", "Premium design"],
    "imageUrl": "https://media-library.felco.com/asset/de84fca4-1fb7-4764-8ee6-36f6571bad6d/Square_packshots_PNG/FELCO_PREMIUM_packshot_F6-png.png",
    "productUrl": "https://www.felco.com/products/felco-6-premium-se",
    "criteria": {
      "handSize": ["medium"],
      "usageType": ["flowers_and_roses", "grapes_and_vineyards", "hedges_and_bushes", "landscaping_and_municipalities", "nurseries"],
      "handedness": "right",
      "userType": ["professional", "amateur"]
    }
  },
  {
    "id": "felco-6-ed-stephane-marie",
    "model": "FELCO 6 Ed. Stéphane Marie",
    "description": "Special edition pruning shear designed with Stéphane Marie",
    "shortSpecs": ["Right-handed", "Medium hand size", "For flowers, vines and nurseries"],
    "imageUrl": "https://media-library.felco.com/asset/6d6e547c-10c7-46e8-b5d2-cc20b3b63017/Square_packshots_PNG/FELCO6_Ed_Stephane_Marie.png",
    "productUrl": "https://www.felco.com/products/felco-6-ed-stephane-marie",
    "criteria": {
      "handSize": ["medium"],
      "usageType": ["flowers_and_roses", "hedges_and_bushes", "landscaping_and_municipalities", "nurseries"],
      "handedness": "right",
      "userType": ["professional", "amateur"]
    }
  },
  {
    "id": "felco-7",
    "model": "FELCO 7",
    "description": "Pruning shear for forestry and vineyard work with rotating handle",
    "shortSpecs": ["Right-handed", "Large hand size", "High performance"],
    "imageUrl": "https://media-library.felco.com/asset/e31fb803-f5e4-4c2f-a45a-b8f16e5bc495/Square_packshots_PNG/FELCO_7.png",
    "productUrl": "https://www.felco.com/products/felco-7",
    "criteria": {
      "handSize": ["large"],
      "usageType": ["arboristry_and_forestry", "fruit_nut_trees_and_orchards", "grapes_and_vineyards", "landscaping_and_municipalities"],
      "handedness": "right",
      "userType": ["professional", "amateur"]
    }
  },
  {
    "id": "felco-8",
    "model": "FELCO 8",
    "description": "Ergonomic pruning shear",
    "shortSpecs": ["Right-handed", "Large hand size", "Ergonomic design"],
    "imageUrl": "https://media-library.felco.com/asset/9fc2ab30-3aa0-412e-af2e-6b8195ccc1c5/Square_packshots_PNG/FELCO_8.png",
    "productUrl": "https://www.felco.com/products/felco-8",
    "criteria": {
      "handSize": ["large"],
      "usageType": ["arboristry_and_forestry", "flowers_and_roses", "fruit_nut_trees_and_orchards", "grapes_and_vineyards", "hedges_and_bushes", "landscaping_and_municipalities", "nurseries"],
      "handedness": "right",
      "userType": ["professional", "amateur"]
    }
  },
  {
    "id": "felco-8-premium-se",
    "model": "FELCO 8 Premium SE",
    "description": "Premium special edition of the FELCO 8 model",
    "shortSpecs": ["Right-handed", "Ergonomic premium design"],
    "imageUrl": "https://media-library.felco.com/asset/94ae94bb-1fa9-4e70-81e8-e18d2949da5e/Square_packshots_PNG/FELCO_PREMIUM_packshot_F8-png.png",
    "productUrl": "https://www.felco.com/products/felco-8-premium-se",
    "criteria": {
      "handSize": ["large"],
      "usageType": ["flowers_and_roses", "grapes_and_vineyards", "hedges_and_bushes", "landscaping_and_municipalities", "nurseries"],
      "handedness": "right",
      "userType": ["professional", "amateur"]
    }
  },
  {
    "id": "felco-8-ed-stephane-marie",
    "model": "FELCO 8 Ed. Stéphane Marie",
    "description": "Special edition ergonomic pruning shear designed with Stéphane Marie",
    "shortSpecs": ["Right-handed", "Large hand size", "Multi-purpose ergonomic"],
    "imageUrl": "https://media-library.felco.com/asset/a37ae9df-8b6d-4c09-ae8f-70cf9c154b84/Square_packshots_PNG/FELCO_8_Stephane_Marie_front.png",
    "productUrl": "https://www.felco.com/products/felco-8-ed-stephane-marie",
    "criteria": {
      "handSize": ["large"],
      "usageType": ["flowers_and_roses", "hedges_and_bushes", "landscaping_and_municipalities", "nurseries"],
      "handedness": "right",
      "userType": ["professional", "amateur"]
    }
  },
  {
    "id": "felco-6-elite",
    "model": "FELCO 6 Elite",
    "description": "Elite version of the compact pruning shear for medium-sized hands",
    "shortSpecs": ["Right-handed", "Medium hand size", "Versatile use"],
    "imageUrl": "https://media-library.felco.com/asset/c36c2b22-e008-4a9e-9f12-374d5e5225c1/Square_packshots_PNG/FELCO_6_ELITE.png",
    "productUrl": "https://www.felco.com/products/felco-6-elite",
    "criteria": {
      "handSize": ["medium"],
      "usageType": ["arboristry_and_forestry", "flowers_and_roses", "fruit_nut_trees_and_orchards", "grapes_and_vineyards", "hedges_and_bushes", "landscaping_and_municipalities", "nurseries"],
      "handedness": "right",
      "userType": ["professional", "amateur"]
    }
  },
  {
    "id": "felco-8-elite",
    "model": "FELCO 8 Elite",
    "description": "Elite version of the ergonomic pruning shear",
    "shortSpecs": ["Right-handed", "Large hand size", "Ergonomic design"],
    "imageUrl": "https://media-library.felco.com/asset/b40b5c1e-81d7-4848-9ac4-0f811f225faf/Square_packshots_PNG/FELCO_8_ELITE.png",
    "productUrl": "https://www.felco.com/products/felco-8-elite",
    "criteria": {
      "handSize": ["large"],
      "usageType": ["arboristry_and_forestry", "flowers_and_roses", "fruit_nut_trees_and_orchards", "grapes_and_vineyards", "hedges_and_bushes", "landscaping_and_municipalities", "nurseries"],
      "handedness": "right",
      "userType": ["professional", "amateur"]
    }
  },
  {
    "id": "felco-9",
    "model": "FELCO 9",
    "description": "Left-handed pruning shear",
    "shortSpecs": ["Left-handed", "Large hand size", "Ergonomic design"],
    "imageUrl": "https://media-library.felco.com/asset/7dd62013-0e04-4945-8702-54917b7dcbd0/Square_packshots_PNG/FELCO_9.png",
    "productUrl": "https://www.felco.com/products/felco-9",
    "criteria": {
      "handSize": ["large"],
      "usageType": ["arboristry_and_forestry", "flowers_and_roses", "fruit_nut_trees_and_orchards", "grapes_and_vineyards", "hedges_and_bushes", "landscaping_and_municipalities", "nurseries"],
      "handedness": "left",
      "userType": ["professional", "amateur"]
    }
  },
  {
    "id": "felco-10",
    "model": "FELCO 10",
    "description": "Left-handed pruning shear for orchards and vineyards with rotating handle",
    "shortSpecs": ["Left-handed", "Large hand size", "Orchard and vineyard use"],
    "imageUrl": "https://media-library.felco.com/asset/a449ddbf-14c7-433e-a1e7-6629c3a57c2c/Square_packshots_PNG/FELCO_10.png",
    "productUrl": "https://www.felco.com/products/felco-10",
    "criteria": {
      "handSize": ["large"],
      "usageType": ["arboristry_and_forestry", "fruit_nut_trees_and_orchards", "grapes_and_vineyards", "landscaping_and_municipalities"],
      "handedness": "left",
      "userType": ["professional", "amateur"]
    }
  },
  {
    "id": "felco-11",
    "model": "FELCO 11",
    "description": "Pruning shear for flowers and nursery work",
    "shortSpecs": ["Right-handed", "Large hand size", "Specialized for delicate pruning"],
    "imageUrl": "https://media-library.felco.com/asset/2afac3e1-896f-450c-a282-500867df88c6/Square_packshots_PNG/FELCO_11.png",
    "productUrl": "https://www.felco.com/products/felco-11",
    "criteria": {
      "handSize": ["large"],
      "usageType": ["flowers_and_roses", "hedges_and_bushes", "nurseries"],
      "handedness": "right",
      "userType": ["professional", "amateur"]
    }
  },
  {
    "id": "felco-12",
    "model": "FELCO 12",
    "description": "Compact pruning shear for orchards and vineyards with rotating handle",
    "shortSpecs": ["Right-handed", "Medium hand size", "Orchard and vineyard use"],
    "imageUrl": "https://media-library.felco.com/asset/f1d56fc7-65ff-4338-89ea-94ff85c30788/Square_packshots_PNG/FELCO_12.png",
    "productUrl": "https://www.felco.com/products/felco-12",
    "criteria": {
      "handSize": ["medium"],
      "usageType": ["arboristry_and_forestry", "fruit_nut_trees_and_orchards", "grapes_and_vineyards", "landscaping_and_municipalities"],
      "handedness": "right",
      "userType": ["professional", "amateur"]
    }
  },
  {
    "id": "felco-13",
    "model": "FELCO 13",
    "description": "Pruning shear for vineyards and landscaping",
    "shortSpecs": ["Right-handed", "Large hand size", "Specialized design"],
    "imageUrl": "https://media-library.felco.com/asset/f90cc033-ae0c-4b35-af4a-f13060f70881/Square_packshots_PNG/FELCO_13.png",
    "productUrl": "https://www.felco.com/products/felco-13",
    "criteria": {
      "handSize": ["large"],
      "usageType": ["fruit_nut_trees_and_orchards", "landscaping_and_municipalities"],
      "handedness": "right",
      "userType": ["professional", "amateur"]
    }
  },
  {
    "id": "felco-14",
    "model": "FELCO 14",
    "description": "Compact pruning shear for small hands",
    "shortSpecs": ["Right-handed", "Small hand size", "Versatile use"],
    "imageUrl": "https://media-library.felco.com/asset/ea975e5a-3cae-4300-90c5-466511bec521/Square_packshots_PNG/FELCO_14.png",
    "productUrl": "https://www.felco.com/products/felco-14",
    "criteria": {
      "handSize": ["small"],
      "usageType": ["arboristry_and_forestry", "flowers_and_roses", "fruit_nut_trees_and_orchards", "grapes_and_vineyards", "hedges_and_bushes", "landscaping_and_municipalities", "nurseries"],
      "handedness": "right",
      "userType": ["professional", "amateur"]
    }
  },
  {
    "id": "felco-14-ed-stephane-marie",
    "model": "FELCO 14 Ed. Stéphane Marie",
    "description": "Special edition compact pruning shear designed with Stéphane Marie",
    "shortSpecs": ["Right-handed", "Small hand size", "Multi-purpose"],
    "imageUrl": "https://media-library.felco.com/asset/3d9fc6de-017e-4f48-bf14-308a931d4804/Square_packshots_PNG/FELCO_14_Stephane_Marie_front.png",
    "productUrl": "https://www.felco.com/products/felco-14-ed-stephane-marie",
    "criteria": {
      "handSize": ["small"],
      "usageType": ["flowers_and_roses", "hedges_and_bushes", "landscaping_and_municipalities", "nurseries"],
      "handedness": "right",
      "userType": ["professional", "amateur"]
    }
  },
  {
    "id": "felco-15",
    "model": "FELCO 15",
    "description": "Compact pruning shear for vineyard work with rotating handle",
    "shortSpecs": ["Right-handed", "Small hand size", "Vineyard specific"],
    "imageUrl": "https://media-library.felco.com/asset/dddfebc3-6abf-4141-9174-4b7a84bd0e6a/Square_packshots_PNG/FELCO_15.png",
    "productUrl": "https://www.felco.com/products/felco-15",
    "criteria": {
      "handSize": ["small"],
      "usageType": ["arboristry_and_forestry", "fruit_nut_trees_and_orchards", "grapes_and_vineyards", "landscaping_and_municipalities"],
      "handedness": "right",
      "userType": ["professional", "amateur"]
    }
  },
  {
    "id": "felco-16",
    "model": "FELCO 16",
    "description": "Left-handed pruning shear for multiple applications",
    "shortSpecs": ["Left-handed", "Medium hand size", "Versatile use"],
    "imageUrl": "https://media-library.felco.com/asset/13e68734-10be-496c-a453-7b28ffb61475/Square_packshots_PNG/FELCO_16.png",
    "productUrl": "https://www.felco.com/products/felco-16",
    "criteria": {
      "handSize": ["medium"],
      "usageType": ["arboristry_and_forestry", "flowers_and_roses", "fruit_nut_trees_and_orchards", "grapes_and_vineyards", "hedges_and_bushes", "landscaping_and_municipalities", "nurseries"],
      "handedness": "left",
      "userType": ["professional", "amateur"]
    }
  },
  {
    "id": "felco-17",
    "model": "FELCO 17",
    "description": "Left-handed pruning shear for multiple applications with rotating handle",
    "shortSpecs": ["Left-handed", "Medium hand size", "Versatile use"],
    "imageUrl": "https://media-library.felco.com/asset/e415a568-0396-4c0a-98d8-a89a6b4fb396/Square_packshots_PNG/FELCO_17.png",
    "productUrl": "https://www.felco.com/products/felco-17",
    "criteria": {
      "handSize": ["medium"],
      "usageType": ["arboristry_and_forestry", "fruit_nut_trees_and_orchards", "grapes_and_vineyards", "landscaping_and_municipalities"],
      "handedness": "left",
      "userType": ["professional", "amateur"]
    }
  },
  {
    "id": "felco-31",
    "model": "FELCO 31",
    "description": "Universal pruning shear for orchards, hedges and landscaping",
    "shortSpecs": ["Universal design", "Large hand size", "Multiple applications"],
    "imageUrl": "https://media-library.felco.com/asset/ee80d049-8a24-4d2b-a236-77f9e38cd842/Square_packshots_PNG/FELCO_31.png",
    "productUrl": "https://www.felco.com/products/felco-31",
    "criteria": {
      "handSize": ["large"],
      "usageType": ["arboristry_and_forestry", "fruit_nut_trees_and_orchards"],
      "handedness": "universal",
      "userType": ["professional", "amateur"]
    }
  },
  {
    "id": "felco-32",
    "model": "FELCO 32",
    "description": "Universal pruning shear for multiple applications",
    "shortSpecs": ["Universal design", "Large hand size", "Multiple applications"],
    "imageUrl": "https://media-library.felco.com/asset/39d39eed-401e-4f31-b1a0-3a7587106cd2/Square_packshots_PNG/FELCO_32.png",
    "productUrl": "https://www.felco.com/products/felco-32",
    "criteria": {
      "handSize": ["large"],
      "usageType": ["fruit_nut_trees_and_orchards"],
      "handedness": "universal",
      "userType": ["professional", "amateur"]
    }
  },
 {
    "id": "felco-171m",
    "model": "FELCO 171M",
    "description": "Pruning shear for multiple applications",
    "shortSpecs": ["Right-handed", "Medium hand size"],
    "imageUrl": "https://media-library.felco.com/asset/6b0baa00-055e-49c2-84f8-f7a724611cd4/Square_packshots_PNG/FELCO-171M-face-closed.png",
    "productUrl": "https://www.felco.com/products/felco-171m",
    "criteria": {
      "handSize": ["small", "medium"],
      "usageType": ["flowers_and_roses", "fruit_nut_trees_and_orchards", "grapes_and_vineyards", "landscaping_and_municipalities", "hedges_and_bushes"],
      "handedness": "right",
      "userType": ["amateur"]
    }
  },
 {
    "id": "felco-171l",
    "model": "FELCO 171L",
    "description": "Pruning shear for multiple applications",
    "shortSpecs": ["Right-handed", "Large hand size"],
    "imageUrl": "https://media-library.felco.com/asset/88369c9c-3024-4ebe-853a-ca2899337f67/Square_packshots_PNG/FELCO-171L-face-closed.png",
    "productUrl": "https://www.felco.com/products/felco-171l",
    "criteria": {
      "handSize": ["large"],
      "usageType": ["flowers_and_roses", "fruit_nut_trees_and_orchards", "grapes_and_vineyards", "landscaping_and_municipalities", "hedges_and_bushes"],
      "handedness": "right",
      "userType": ["amateur"]
    }
  },
]; 